<script lang="ts">
	export let index: number;
	export let question: string;
	export let answer: string;
	export let points: number;
	export let onUpdate: (correct: boolean) => void;

	let collapsed = true;
	let correct: boolean | null = null; // correct, incorrect, not yet answered.

	function toggleAccordion() {
		collapsed = !collapsed;
	}

	function selectNope() {
		correct = false;
		onUpdate(correct);
	}

	function selectYep() {
		correct = true;
		onUpdate(correct);
	}
</script>

<div class="question-card">
	<div class="question">
		<div class="number">
			{index + 1}
		</div>
		<p>{@html question}</p>
		<div class="points">
			+{points}
		</div>
	</div>
	<button class="accordion" on:click={toggleAccordion}>
		<span class="label">{collapsed ? 'Show' : 'Hide'} answer</span>
		<span class="material-symbols-rounded icon">
			{collapsed ? 'expand_more' : 'expand_less'}
		</span>
	</button>
	<div class="panel" class:collapsed>
		<p>{@html answer}</p>
		<div class="buttons">
			<button class="wrong selected" class:selected={correct === false} on:click={selectNope}>
				Nope
			</button>

			<button class="right selected" class:selected={correct === true} on:click={selectYep}>
				I got it!
			</button>
		</div>
	</div>
</div>

<style>
	.question-card {
		background-color: #fff;
		border-radius: 12px;
		display: flex;
		flex-direction: column;
		padding: 16px;
	}

	.question {
		display: flex;
		flex-direction: row;
		gap: 16px;
	}

	.number {
		border-radius: 100%;
		border: 1px solid #e8ceff;
		height: 32px;
		width: 32px;
		text-align: center;
		color: #772255;
		font-size: 14px;
		line-height: 32px;
		flex-shrink: 0;
	}

	.points {
		color: #772255;
		font-size: 14px;
		white-space: nowrap;
	}

	.question p {
		flex-grow: 1;
		margin: 0;
	}

	.accordion {
		cursor: pointer;
		font-size: 14px;
		line-height: 24px;
		background-color: #f8f0ff;
		color: #5c00d1;
		border: none;
		display: flex;
		flex-direction: row;
		padding: 12px 12px 12px 16px;
		border-radius: 4px 4px 0 0;
		margin-top: 20px;
	}

	.label {
		text-align: left;
		flex-grow: 1;
	}

	.panel {
		background-color: #f8f0ff;
		padding: 20px 16px 16px;
		border-radius: 0 0 4px 4px;
		border-top: 1px solid #ead9ff;
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.panel p {
		margin: 0;
		font-size: 16px;
		line-height: 24px;
	}

	.panel.collapsed {
		display: none;
	}

	.buttons {
		display: flex;
		flex-direction: row;
		gap: 8px;
	}

	.buttons button {
		background-color: #fff;
		border: none;
		flex-grow: 1;
		height: 44px;
		border-radius: 4px;
		font-size: 16px;
		line-height: 20px;
		cursor: pointer;
	}

	.wrong {
		color: #d63e3e;
	}

	.right {
		color: #257400;
	}

	.wrong.selected {
		background-color: #d63e3e;
		color: #fff;
	}

	.right.selected {
		background-color: #257400;
		color: #fff;
	}
</style>
